import React, { useState, useEffect } from "react";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/loader";
import SelectMonth from "../../../components/selectMonth";
import { getDaysInMonth } from "../../../utils";
import toast from "react-hot-toast";

export default function Occupation({ user }) {
  const [date, setDate] = useState(null);

  if (!user) return <Loader />;

  return (
    <div className="bg-white border-[1px] border-gray-200 rounded-md overflow-hidden w-screen md:w-full">
      <div className="flex flex-wrap gap-5 p-2 md:!px-8">
        <div className="flex-1">
          <h2 className="text-lg font-semibold">Occupation - {user.firstName} {user.lastName}</h2>
        </div>
        <SelectMonth start={-11} indexDefaultValue={11} value={date} onChange={(e) => setDate(e.target.value)} showArrows />
      </div>
      {date && user && <Activities date={new Date(date)} user={user} />}
    </div>
  );
}

const Activities = ({ date, user }) => {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    get();
  }, [date, user]);

  const navigate = useNavigate();

  async function get() {
    try {
      const { ok, data } = await api.post(`/activity/search`, { date: date.getTime(), userId: user._id });
      if (!ok) return toast.error("Error while fetching activities");
      setActivities(data);
    } catch (e) {
      console.error(e);
    }
  }

  const days = getDaysInMonth(date.getMonth(), date.getFullYear());

  const getWorkingDays = () => {
    return days.reduce((acc, a) => {
      const day = a.getDay();
      if (day === 0 || day == 6) return acc;
      return acc + 1;
    }, 0);
  };

  const getTotal = () => (activities.reduce((acc, a) => acc + a.total, 0) / 8).toFixed(2);
  const isHoursFilled = parseFloat(getTotal()) >= 5;

  return (
    <div className="flex flex-wrap py-3 gap-4 text-black">
      <div className="w-screen md:w-full p-2 md:!px-8">
        {!isHoursFilled && (
          <div className="bg-yellow-50 border-t border-yellow-200 p-3 md:px-8">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">Warning</h3>
                <div className="mt-1 text-sm text-yellow-700">
                  <p>This user hasn't filled their hours for the past week.</p>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="mt-2 rounded-xl bg-[#fff] overflow-auto">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="py-[10px] text-[14px] font-bold text-[#212325] text-left pl-[10px]">Invoices</th>
                  {days.map((e) => {
                    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                    const _date = new Date(e);
                    const day = _date.getDay();
                    const weekday = days[day];
                    const date = _date.getDate();
                    return (
                      <th
                        className={`w-[20px] border border-[#E5EAEF] text-[12px] font-semibold text-center ${
                          day == 0 || day == 6 ? "bg-[#FFD5F1]" : "bg-[white]"
                        }`}
                        key={e}
                        day={day}>
                        <div>{weekday}</div>
                        <div>{date}</div>
                      </th>
                    );
                  })}
                  <th className={`w-[20px] border border-[#E5EAEF] text-[12px] font-semibold text-center bg-[white]`} />
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-b border-r border-[#E5EAEF]">
                  <th className="px-2">
                    <div className="flex justify-end w-full text-[12px] font-bold text-[#212325] italic">
                      <div>{`${getTotal()} / ${getWorkingDays()} days`}</div>
                    </div>
                  </th>
                  {days.map((e, i) => {
                    const v = activities.reduce((acc, a) => {
                      if (!a.detail[i]) return acc;
                      return acc + a.detail[i].value;
                    }, 0);
                    return <Field key={`day-${i}`} value={v} disabled />;
                  })}
                  <th className={`border border-[#E5EAEF] py-[6px]`}>
                    <div className="w-6"></div>
                  </th>
                </tr>
                {activities.map((e, i) => {
                  return (
                    <React.Fragment key={`1-${e._id}`}>
                      <tr className="border-t border-b border-r border-[#E5EAEF]" key={`1-${e._id}`}>
                        <th className="w-[100px] border-t border-b border-r text-[12px] font-bold text-[#212325] text-left">
                          <div className="flex flex-1 items-center justify-between gap-1 px-2">
                            <div className="flex flex-col flex-1 items-center justify-start cursor-pointer" onClick={() => navigate(`/project/${e.projectId}`)}>
                              <div> {e.projectName}</div>
                              <div className="text-xs italic font-normal">{e.budgetName}</div>
                            </div>
                            <div className="flex flex-col items-end">
                              <div className="text-xs italic font-normal">{(e.total / 8).toFixed(2)} days</div>
                              <div className="text-[10px] italic font-normal">{(((e.total / 8).toFixed(2) / getTotal()) * 100).toFixed(2)}%</div>
                            </div>
                          </div>
                        </th>
                        {e.detail.map((f, j) => {
                          return <Field key={`${e.projectName} ${j}`} freezed={e.freezed} value={f.value || 0} disabled />;
                        })}
                        <th className={`border border-[#E5EAEF] py-[6px]`}>
                          <div className="w-6"></div>
                        </th>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const Field = ({ value = 0, disabled, freezed, ...rest }) => {
  let bgColor = freezed === "yes" ? "bg-[#F0F0F0]" : "bg-[white]";
  let textColor = "text-[#000]";
  
  if (value >= 7) {
    bgColor = "bg-[#216E39]";
    textColor = "text-[#fff]";
  } else if (value >= 5) {
    bgColor = "bg-[#30A14E]";
  } else if (value >= 3) {
    bgColor = "bg-[#40C463]";
  } else if (value > 0) {
    bgColor = "bg-[#9BE9A8]";
  } else {
    textColor = "text-[#aaa]";
  }

  return (
    <th className={`border border-[#E5EAEF] py-[6px] px-0 ${bgColor} m-0`}>
      <input
        className={`border-none min-w-[30px] w-full text-center ${bgColor} ${textColor} p-0`}
        disabled={true}
        value={parseFloat(value)}
        min={0}
        {...rest}
        type="number"
        step="0.1"
        readOnly
      />
    </th>
  );
};